import React from 'react'

const Icon = React.forwardRef(
  (
    {
      children,
      color = 'inherit',
      fontSize = 'default',
      sx = {},
      className = '',
      ...props
    },
    ref
  ) => {
    // Get icon styles based on color and fontSize
    const getIconStyles = () => {
      const baseStyles = {
        display: 'inline-block',
        fill: 'currentColor',
        flexShrink: 0,
        userSelect: 'none',
        transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
      }

      // Font size variations
      const fontSizeStyles = {
        inherit: {
          fontSize: 'inherit'
        },
        small: {
          fontSize: '1.125rem'
        },
        default: {
          fontSize: '1.5rem'
        },
        large: {
          fontSize: '2.25rem'
        }
      }

      // Color variations
      const colorStyles = {
        inherit: {
          color: 'inherit'
        },
        action: {
          color: 'rgba(0, 0, 0, 0.54)'
        },
        disabled: {
          color: 'rgba(0, 0, 0, 0.38)'
        },
        primary: {
          color: '#1976d2'
        },
        secondary: {
          color: '#9c27b0'
        },
        error: {
          color: '#d32f2f'
        },
        warning: {
          color: '#ed6c02'
        },
        info: {
          color: '#0288d1'
        },
        success: {
          color: '#2e7d32'
        }
      }

      return {
        ...baseStyles,
        ...fontSizeStyles[fontSize],
        ...colorStyles[color],
        ...sx
      }
    }

    const styles = getIconStyles()

    return (
      <span ref={ref} className={className} style={styles} {...props}>
        {children}
      </span>
    )
  }
)

Icon.displayName = 'Icon'

export default Icon
